const LEGAL_CONTENT_ES = {
  effectiveDate: '01 de junio de 2026',
  intro: [
    '¡Bienvenido a Enrola!',
    'Nos emociona acompañarte en el crecimiento de tu negocio. Este documento constituye un acuerdo legal y vinculante (el "Acuerdo") entre ENROLA, LLC, una compañía de responsabilidad limitada constituida en el Estado de Nevada, Estados Unidos ("Enrola", "nosotros", "nuestro" o "nos") y la empresa, entidad o individuo que accede a nuestra plataforma ("Cliente", "Comerciante", "Distribuidor", "Afiliado" o "Usuario").',
    'Al acceder, utilizar o registrarte en los servicios proporcionados por Enrola a través del sitio web www.enrolanow.com, nuestra aplicación o plataforma (los "Servicios"), reconoces que has leído, comprendido y aceptado en su totalidad estos Términos de Servicio y Políticas de Privacidad.',
    'Si no estás de acuerdo con alguna parte de este documento, te pedimos que no utilices nuestros Servicios.',
  ],
  termsSections: [
    {
      id: 'terms-1',
      title: '1. Naturaleza de los Servicios y Elegibilidad B2B',
      subsections: [
        {
          title: '1.1. Nuestro Propósito',
          body: 'Enrola es una plataforma tecnológica (SaaS) que permite a las empresas y distribuidores crear, gestionar y automatizar programas de referidos inteligentes. Nuestra misión es ayudarte a convertir a tus clientes satisfechos en promotores de tu marca, facilitando el seguimiento en tiempo real, impulsando la lealtad y escalando tus ventas de forma medible y organizada.',
        },
        {
          title: '1.2. Uso Exclusivamente Comercial (B2B)',
          body: 'Enrola es un servicio diseñado exclusivamente para empresas y profesionales independientes. Al utilizar la Plataforma, confirmas que lo haces con fines comerciales y no para propósitos personales, domésticos o familiares.',
        },
        {
          title: '1.3. Mayoría de Edad Estricta',
          body: 'Para crear una cuenta y utilizar los Servicios (ya sea como Comerciante, Distribuidor o Afiliado), debes tener al menos 18 años de edad. Enrola no permite el uso de su plataforma a menores de edad bajo ninguna circunstancia, en estricto cumplimiento de las leyes federales de Estados Unidos.',
        },
      ],
    },
    {
      id: 'terms-2',
      title: '2. Términos para Comerciantes y Distribuidores',
      subsections: [
        {
          title: '2.1. Gestión de la Plataforma',
          body: 'Como Comerciante, tú eres responsable de configurar tu programa de referidos, administrar tu base de datos de clientes y establecer las comisiones o recompensas aplicables a tus representantes de marca o Afiliados.',
        },
        {
          title: '2.2. Tarifas y Facturación',
          body: 'Enrola cobra tarifas de suscripción por el uso de la plataforma. Estas tarifas se facturan por adelantado y no son reembolsables. Nos reservamos el derecho de modificar nuestros precios, lo cual notificaremos con al menos 30 días de anticipación.',
        },
        {
          title: '2.3. Exención de Garantías Comerciales',
          body: 'Aunque Enrola te proporciona las herramientas para impulsar tus ventas y expandir tu red, el éxito comercial de tu programa de referidos depende enteramente de tu gestión. Enrola no garantiza un incremento específico en ventas o prospectos.',
        },
      ],
    },
    {
      id: 'terms-3',
      title: '3. Procesamiento de Pagos y Recompensas',
      subsections: [
        {
          title: '3.1. Uso de Proveedores Externos',
          body: 'Enrola es una plataforma de software, no es un banco ni un transmisor de dinero. Todo el procesamiento de pagos, incluyendo el cobro de suscripciones y la distribución de recompensas o comisiones a los Afiliados, se realiza a través de procesadores de pago externos de terceros (como Stripe, PayPal, Tremendous).',
        },
        {
          title: '3.2. Responsabilidad de Fondeo',
          body: 'El Comerciante es el único responsable de asegurar que existan fondos suficientes en su cuenta del procesador de pagos para cubrir las recompensas adeudadas a sus Afiliados. Enrola facilita el cálculo y la orden de dispersión mediante software, pero en ningún momento toca, retiene, ni administra el dinero de los Usuarios en cuentas corporativas propias.',
        },
        {
          title: '3.3. Relación con los Afiliados',
          body: 'La contratación y el pago a cualquier Afiliado es una relación directa entre el Comerciante y el Afiliado. Enrola no es parte de esa relación laboral ni comercial, y se exime de cualquier disputa por pagos tardíos, falta de fondos o retenciones fiscales (formularios W-9 o 1099).',
        },
      ],
    },
    {
      id: 'terms-4',
      title: '4. Publicidad, Monetización de Datos e Inteligencia Artificial (IA)',
      subsections: [
        {
          title: '4.1. Publicidad en la Plataforma',
          body: 'Como parte de nuestro modelo de negocio para mantener la accesibilidad de los Servicios, Enrola muestra anuncios publicitarios, promociones y ofertas patrocinadas dentro de la interfaz de la Plataforma. Al utilizar Enrola, aceptas recibir dicha publicidad, la cual puede estar segmentada según tu actividad y perfil.',
        },
        {
          title: '4.2. Venta y Monetización de Datos de Afiliados',
          body: 'Aceptas expresamente que el modelo de negocio de Enrola incluye la comercialización, licenciamiento y venta de datos e información no confidencial de los Afiliados a empresas de terceros y socios estratégicos. Esto se realiza en estricto cumplimiento con las leyes de privacidad aplicables, y los usuarios tienen opciones de exclusión detalladas en nuestra Política de Privacidad.',
        },
        {
          title: '4.3. Funciones de IA en Enrola',
          body: 'Para optimizar tu experiencia, Enrola utiliza modelos de Inteligencia Artificial (IA) destinados a asistir a los comerciantes y afiliados en el seguimiento de referidos y análisis predictivo de ventas.',
        },
        {
          title: '4.4. Derecho de Exclusión (Opt-out) para Entrenamiento de IA',
          body: 'Eres dueño del contenido que ingresas. Tienes el derecho absoluto de negarte a que tus Entradas y Salidas se utilicen para entrenar nuestros modelos de IA enviando un correo a privacy@enrolanow.com. Si te niegas, garantizamos que tus datos no serán utilizados para propósitos de entrenamiento de IA.',
        },
      ],
    },
    {
      id: 'terms-5',
      title: '5. Propiedad Intelectual y Reglas de Uso',
      subsections: [
        {
          title: '5.1. Licencia de Uso',
          body: 'Te otorgamos una licencia limitada, no exclusiva, revocable e intransferible para acceder a la Plataforma Enrola. El código fuente, diseño, logotipos, algoritmos de IA y estructura de la plataforma son propiedad exclusiva de ENROLA, LLC.',
        },
        {
          title: '5.2. Usos Prohibidos',
          body: 'Te comprometes a NO: (i) infringir leyes aplicables de EE. UU.; (ii) utilizar la plataforma para esquemas piramidales ilegales, fraude o lavado de dinero; (iii) aplicar ingeniería inversa, descompilar o intentar extraer el código fuente o los modelos de IA de Enrola; (iv) utilizar "bots" o "scrapers" para extraer información de la plataforma.',
        },
      ],
    },
    {
      id: 'terms-6',
      title: '6. Limitación de Responsabilidad e Indemnización',
      subsections: [
        {
          title: '6.1. Servicio "Tal Cual" (AS IS)',
          body: 'Los Servicios se proporcionan "tal cual" y "según disponibilidad". En la máxima medida permitida por la ley de EE. UU., Enrola renuncia a todas las garantías implícitas, incluyendo comerciabilidad o idoneidad para un propósito particular.',
        },
        {
          title: '6.2. Límite Máximo de Responsabilidad',
          body: 'Bajo ninguna circunstancia Enrola será responsable por daños indirectos, incidentales, lucro cesante o pérdida de datos. La responsabilidad total de Enrola hacia ti nunca excederá el monto total de las tarifas que nos hayas pagado en los seis (6) meses anteriores al evento que originó el reclamo.',
        },
        {
          title: '6.3. Indemnización',
          body: 'Aceptas defender, indemnizar y eximir de responsabilidad a ENROLA, LLC, sus directivos y empleados contra cualquier reclamo, demanda o gasto legal (incluidos honorarios de abogados) que surja de tu uso indebido de la plataforma, el incumplimiento de tus pagos a Afiliados, o la violación de este Acuerdo.',
        },
      ],
    },
    {
      id: 'terms-7',
      title: '7. Resolución de Disputas',
      subsections: [
        {
          title: '7.1. Ley Aplicable',
          body: 'Este Acuerdo se regirá e interpretará exclusivamente de acuerdo con las leyes del Estado de Nevada, Estados Unidos, y las leyes federales aplicables.',
        },
        {
          title: '7.2. Arbitraje Vinculante',
          body: 'Cualquier disputa derivada de este Acuerdo será resuelta de manera definitiva mediante arbitraje vinculante administrado por la American Arbitration Association (AAA), con sede en el Condado de Clark, Nevada.',
        },
        {
          title: '7.3. Excepción de Reclamos Menores',
          body: 'Cualquiera de las partes puede presentar demandas individuales ante un Tribunal de Reclamos Menores (Small Claims Court) en el Condado de Clark, Nevada.',
        },
        {
          title: '7.4. Renuncia a Demandas Colectivas (Class Action Waiver) y Juicio por Jurado',
          body: 'Aceptas expresamente que cualquier disputa se llevará a cabo únicamente de forma individual, y no como parte de una acción colectiva o representativa. Ambas partes renuncian irrevocablemente al derecho a un juicio por jurado.',
        },
      ],
    },
  ],
  privacySections: [
    {
      id: 'privacy-intro',
      body: 'Esta Política de Privacidad explica cómo ENROLA, LLC recopila, utiliza, protege, comparte y vende tu Información Personal cuando utilizas nuestra Plataforma. Esta política está diseñada para cumplir con las normativas federales y estatales aplicables en los Estados Unidos (incluidas la CCPA/CPRA de California y la NRS 603A de Nevada).',
    },
    {
      id: 'privacy-1',
      title: '1. Información que Recopilamos',
      items: [
        'Identificadores y Datos de Contacto: Nombre, apellidos, nombre de empresa, dirección de correo electrónico, dirección postal comercial y número de teléfono.',
        'Datos Financieros: Información necesaria para procesar tus pagos de suscripción o facilitar cobros (gestionada mediante terceros como Stripe, PayPal, Tremendous).',
        'Datos de Uso y Dispositivo: Dirección IP, tipo de navegador, sistema operativo e interacciones con los anuncios dentro de la aplicación.',
        'Contenido del Usuario: La información de los prospectos y campañas que subes a nuestra plataforma.',
      ],
    },
    {
      id: 'privacy-2',
      title: '2. Cómo Utilizamos tu Información',
      intro: 'Utilizamos tus datos para los siguientes propósitos comerciales:',
      items: [
        'Proveer, mantener y asegurar el funcionamiento de la plataforma.',
        'Mostrar Publicidad: Ofrecerte anuncios publicitarios dirigidos, patrocinios y ofertas promocionales de terceros dentro de la plataforma Enrola.',
        'Monetización: Comercializar, licenciar o vender información específica de los perfiles de los Afiliados a redes de anunciantes, empresas de marketing y otros terceros comerciales.',
        'Entrenar nuestros modelos de IA (sujeto a tu derecho de exclusión Opt-out).',
      ],
    },
    {
      id: 'privacy-3',
      title: '3. Cookies y Publicidad Dirigida',
      body: 'Utilizamos cookies y tecnologías de rastreo (como píxeles y etiquetas) para analizar el tráfico, gestionar las sesiones y, fundamentalmente, para mostrar publicidad relevante dentro de la plataforma. Permitimos que socios publicitarios de terceros recopilen ciertos datos de tu dispositivo para mostrarte anuncios basados en tus intereses.',
    },
    {
      id: 'privacy-4',
      title: '4. Compartición y VENTA de Datos',
      intro: 'Para mantener la viabilidad de nuestro modelo de negocio, ENROLA, LLC "vende" y "comparte" información personal según la definición de las leyes de privacidad de Estados Unidos (como la CCPA de California y la NRS 603A de Nevada).',
      items: [
        'Datos de Afiliados que Vendemos: Vendemos identificadores comerciales (nombre, correo electrónico, perfil profesional e historial general de rendimiento) de nuestros Afiliados a empresas asociadas, agencias de marketing y redes B2B para sus propios fines de prospección y publicidad.',
        'Proveedores de Servicios: También compartimos datos con empresas de alojamiento web (AWS) y procesadores de pago (Stripe, PayPal, Tremendous), quienes actúan como proveedores de servicios y tienen prohibido utilizar tus datos para sus propios fines.',
      ],
    },
    {
      id: 'privacy-5',
      title: '5. Derechos de Privacidad Estatales en EE. UU.',
      intro: 'Si eres residente de California, Nevada, Virginia, Colorado, Texas u otros estados aplicables, la ley te otorga derechos estrictos sobre tus datos:',
      items: [
        'Derecho de Exclusión de Venta ("Do Not Sell My Personal Information"): Tienes el derecho absoluto en cualquier momento de indicarnos que no vendamos ni compartamos tu información personal con terceros. Puedes ejercer este derecho enviando un correo a privacy@enrolanow.com con el asunto "Do Not Sell My Info".',
        'Derecho a Saber / Acceso: Solicitar qué información hemos recopilado y a quién se la hemos vendido.',
        'Derecho a Eliminación: Solicitar la eliminación de tu información de nuestros sistemas.',
        'No Discriminación: No te negaremos el uso básico de la plataforma por ejercer tus derechos de privacidad, aunque algunas funciones publicitarias personalizadas podrían dejar de estar disponibles.',
      ],
    },
    {
      id: 'privacy-6',
      title: '6. Privacidad Infantil',
      body: 'La plataforma Enrola está destinada exclusivamente a un público adulto. No recopilamos, compartimos ni vendemos a sabiendas información de menores de 18 años. Si descubrimos que hemos recopilado datos de un menor, los eliminaremos inmediatamente de nuestras bases de datos comerciales.',
    },
    {
      id: 'privacy-7',
      title: '7. Seguridad de los Datos',
      body: 'Implementamos medidas de seguridad administrativas y técnicas (como cifrado) para proteger tu información contra accesos cibernéticos no autorizados.',
    },
    {
      id: 'privacy-8',
      title: '8. Contacto Legal y "No Vender Mi Información"',
      body: 'Para ejercer tu derecho a no vender tu información personal, hacer preguntas sobre esta política o enviar notificaciones legales, comunícate con nuestro equipo legal:\n\nENROLA, LLC\nDirección: 3930 Paradise Rd, Las Vegas, NV 89169, Estados Unidos.\nCorreo electrónico: privacy@enrolanow.com',
    },
  ],
};

const LEGAL_CONTENT_EN = {
  effectiveDate: 'June 1, 2026',
  intro: [
    'Welcome to Enrola!',
    'We are excited to support you as your business grows. This document constitutes a legally binding agreement (the "Agreement") between ENROLA, LLC, a limited liability company formed in the State of Nevada, United States ("Enrola", "we", "our", or "us") and the company, entity, or individual accessing our platform ("Client", "Merchant", "Distributor", "Affiliate", or "User").',
    'By accessing, using, or registering for the services provided by Enrola through the website www.enrolanow.com, our application, or platform (the "Services"), you acknowledge that you have read, understood, and fully accepted these Terms of Service and Privacy Policy.',
    'If you do not agree with any part of this document, please do not use our Services.',
  ],
  termsSections: [
    {
      id: 'terms-1',
      title: '1. Nature of the Services and B2B Eligibility',
      subsections: [
        {
          title: '1.1. Our Purpose',
          body: 'Enrola is a technology platform (SaaS) that enables businesses and distributors to create, manage, and automate smart referral programs. Our mission is to help you turn satisfied customers into brand advocates by enabling real-time tracking, driving loyalty, and scaling your sales in a measurable and organized way.',
        },
        {
          title: '1.2. Commercial Use Only (B2B)',
          body: 'Enrola is a service designed exclusively for businesses and independent professionals. By using the Platform, you confirm that you are doing so for commercial purposes and not for personal, household, or family purposes.',
        },
        {
          title: '1.3. Strict Age Requirement',
          body: 'To create an account and use the Services (whether as a Merchant, Distributor, or Affiliate), you must be at least 18 years of age. Enrola does not permit use of its platform by minors under any circumstances, in strict compliance with United States federal laws.',
        },
      ],
    },
    {
      id: 'terms-2',
      title: '2. Terms for Merchants and Distributors',
      subsections: [
        {
          title: '2.1. Platform Management',
          body: 'As a Merchant, you are responsible for configuring your referral program, managing your customer database, and setting the commissions or rewards applicable to your brand representatives or Affiliates.',
        },
        {
          title: '2.2. Fees and Billing',
          body: 'Enrola charges subscription fees for use of the platform. These fees are billed in advance and are non-refundable. We reserve the right to modify our pricing, which we will notify you of at least 30 days in advance.',
        },
        {
          title: '2.3. Disclaimer of Commercial Warranties',
          body: 'Although Enrola provides you with tools to boost your sales and expand your network, the commercial success of your referral program depends entirely on your management. Enrola does not guarantee a specific increase in sales or leads.',
        },
      ],
    },
    {
      id: 'terms-3',
      title: '3. Payment Processing and Rewards',
      subsections: [
        {
          title: '3.1. Use of Third-Party Providers',
          body: 'Enrola is a software platform; it is not a bank or money transmitter. All payment processing, including subscription billing and the distribution of rewards or commissions to Affiliates, is handled through third-party external payment processors (such as Stripe, PayPal, Tremendous).',
        },
        {
          title: '3.2. Funding Responsibility',
          body: 'The Merchant is solely responsible for ensuring that sufficient funds are available in their payment processor account to cover rewards owed to their Affiliates. Enrola facilitates calculation and disbursement orders through software, but at no time does it touch, hold, or manage User funds in its own corporate accounts.',
        },
        {
          title: '3.3. Relationship with Affiliates',
          body: 'Engaging and paying any Affiliate is a direct relationship between the Merchant and the Affiliate. Enrola is not a party to that employment or commercial relationship and disclaims any disputes regarding late payments, insufficient funds, or tax withholdings (W-9 or 1099 forms).',
        },
      ],
    },
    {
      id: 'terms-4',
      title: '4. Advertising, Data Monetization, and Artificial Intelligence (AI)',
      subsections: [
        {
          title: '4.1. Advertising on the Platform',
          body: 'As part of our business model to keep the Services accessible, Enrola displays advertisements, promotions, and sponsored offers within the Platform interface. By using Enrola, you agree to receive such advertising, which may be targeted based on your activity and profile.',
        },
        {
          title: '4.2. Sale and Monetization of Affiliate Data',
          body: 'You expressly agree that Enrola\'s business model includes the commercialization, licensing, and sale of non-confidential Affiliate data and information to third-party companies and strategic partners. This is done in strict compliance with applicable privacy laws, and users have detailed opt-out options in our Privacy Policy.',
        },
        {
          title: '4.3. AI Features in Enrola',
          body: 'To optimize your experience, Enrola uses Artificial Intelligence (AI) models designed to assist merchants and affiliates with referral tracking and predictive sales analysis.',
        },
        {
          title: '4.4. Opt-Out Right for AI Training',
          body: 'You own the content you submit. You have the absolute right to refuse the use of your Inputs and Outputs for training our AI models by sending an email to privacy@enrolanow.com. If you opt out, we guarantee that your data will not be used for AI training purposes.',
        },
      ],
    },
    {
      id: 'terms-5',
      title: '5. Intellectual Property and Rules of Use',
      subsections: [
        {
          title: '5.1. License to Use',
          body: 'We grant you a limited, non-exclusive, revocable, and non-transferable license to access the Enrola Platform. The source code, design, logos, AI algorithms, and platform structure are the exclusive property of ENROLA, LLC.',
        },
        {
          title: '5.2. Prohibited Uses',
          body: 'You agree NOT to: (i) violate applicable U.S. laws; (ii) use the platform for illegal pyramid schemes, fraud, or money laundering; (iii) reverse engineer, decompile, or attempt to extract the source code or AI models of Enrola; (iv) use "bots" or "scrapers" to extract information from the platform.',
        },
      ],
    },
    {
      id: 'terms-6',
      title: '6. Limitation of Liability and Indemnification',
      subsections: [
        {
          title: '6.1. "As Is" Service',
          body: 'The Services are provided "as is" and "as available." To the maximum extent permitted by U.S. law, Enrola disclaims all implied warranties, including merchantability or fitness for a particular purpose.',
        },
        {
          title: '6.2. Maximum Liability Cap',
          body: 'Under no circumstances will Enrola be liable for indirect, incidental, lost profits, or loss of data. Enrola\'s total liability to you shall never exceed the total amount of fees you have paid us in the six (6) months prior to the event giving rise to the claim.',
        },
        {
          title: '6.3. Indemnification',
          body: 'You agree to defend, indemnify, and hold harmless ENROLA, LLC, its officers, and employees against any claim, lawsuit, or legal expense (including attorneys\' fees) arising from your misuse of the platform, failure to pay Affiliates, or violation of this Agreement.',
        },
      ],
    },
    {
      id: 'terms-7',
      title: '7. Dispute Resolution',
      subsections: [
        {
          title: '7.1. Governing Law',
          body: 'This Agreement shall be governed by and construed exclusively in accordance with the laws of the State of Nevada, United States, and applicable federal laws.',
        },
        {
          title: '7.2. Binding Arbitration',
          body: 'Any dispute arising from this Agreement shall be finally resolved through binding arbitration administered by the American Arbitration Association (AAA), seated in Clark County, Nevada.',
        },
        {
          title: '7.3. Small Claims Exception',
          body: 'Either party may bring individual claims in a Small Claims Court in Clark County, Nevada.',
        },
        {
          title: '7.4. Class Action Waiver and Jury Trial Waiver',
          body: 'You expressly agree that any dispute will be conducted solely on an individual basis, and not as part of a class or representative action. Both parties irrevocably waive the right to a jury trial.',
        },
      ],
    },
  ],
  privacySections: [
    {
      id: 'privacy-intro',
      body: 'This Privacy Policy explains how ENROLA, LLC collects, uses, protects, shares, and sells your Personal Information when you use our Platform. This policy is designed to comply with applicable federal and state regulations in the United States (including California\'s CCPA/CPRA and Nevada\'s NRS 603A).',
    },
    {
      id: 'privacy-1',
      title: '1. Information We Collect',
      items: [
        'Identifiers and Contact Data: First name, last name, company name, email address, business mailing address, and phone number.',
        'Financial Data: Information necessary to process your subscription payments or facilitate collections (managed through third parties such as Stripe, PayPal, Tremendous).',
        'Usage and Device Data: IP address, browser type, operating system, and interactions with in-app advertisements.',
        'User Content: Lead and campaign information you upload to our platform.',
      ],
    },
    {
      id: 'privacy-2',
      title: '2. How We Use Your Information',
      intro: 'We use your data for the following business purposes:',
      items: [
        'Provide, maintain, and secure the operation of the platform.',
        'Display Advertising: Offer you targeted advertisements, sponsorships, and third-party promotional offers within the Enrola platform.',
        'Monetization: Commercialize, license, or sell specific Affiliate profile information to ad networks, marketing companies, and other commercial third parties.',
        'Train our AI models (subject to your opt-out right).',
      ],
    },
    {
      id: 'privacy-3',
      title: '3. Cookies and Targeted Advertising',
      body: 'We use cookies and tracking technologies (such as pixels and tags) to analyze traffic, manage sessions, and, fundamentally, to display relevant advertising within the platform. We allow third-party advertising partners to collect certain data from your device to show you ads based on your interests.',
    },
    {
      id: 'privacy-4',
      title: '4. Sharing and SALE of Data',
      intro: 'To maintain the viability of our business model, ENROLA, LLC "sells" and "shares" personal information as defined under U.S. privacy laws (such as California\'s CCPA and Nevada\'s NRS 603A).',
      items: [
        'Affiliate Data We Sell: We sell business identifiers (name, email, professional profile, and general performance history) of our Affiliates to partner companies, marketing agencies, and B2B networks for their own prospecting and advertising purposes.',
        'Service Providers: We also share data with web hosting companies (AWS) and payment processors (Stripe, PayPal, Tremendous), who act as service providers and are prohibited from using your data for their own purposes.',
      ],
    },
    {
      id: 'privacy-5',
      title: '5. U.S. State Privacy Rights',
      intro: 'If you are a resident of California, Nevada, Virginia, Colorado, Texas, or other applicable states, the law grants you strict rights over your data:',
      items: [
        'Right to Opt Out of Sale ("Do Not Sell My Personal Information"): You have the absolute right at any time to tell us not to sell or share your personal information with third parties. You may exercise this right by emailing privacy@enrolanow.com with the subject line "Do Not Sell My Info".',
        'Right to Know / Access: Request what information we have collected and to whom we have sold it.',
        'Right to Deletion: Request deletion of your information from our systems.',
        'Non-Discrimination: We will not deny you basic use of the platform for exercising your privacy rights, although some personalized advertising features may become unavailable.',
      ],
    },
    {
      id: 'privacy-6',
      title: '6. Children\'s Privacy',
      body: 'The Enrola platform is intended exclusively for an adult audience. We do not knowingly collect, share, or sell information from anyone under 18 years of age. If we discover that we have collected data from a minor, we will immediately delete it from our commercial databases.',
    },
    {
      id: 'privacy-7',
      title: '7. Data Security',
      body: 'We implement administrative and technical security measures (such as encryption) to protect your information against unauthorized cyber access.',
    },
    {
      id: 'privacy-8',
      title: '8. Legal Contact and "Do Not Sell My Information"',
      body: 'To exercise your right not to sell your personal information, ask questions about this policy, or send legal notices, contact our legal team:\n\nENROLA, LLC\nAddress: 3930 Paradise Rd, Las Vegas, NV 89169, United States.\nEmail: privacy@enrolanow.com',
    },
  ],
};

const LEGAL_CONTENT_BY_LOCALE = {
  es: LEGAL_CONTENT_ES,
  en: LEGAL_CONTENT_EN,
};

export function getLegalContent(language) {
  return LEGAL_CONTENT_BY_LOCALE[language] ?? LEGAL_CONTENT_EN;
}
